import { Icon, Spacer } from "@dspworkplace/ui";
import { WarningWrapper } from "./styled";

const PunchRemindersInactivePayroll = () => {

    return (
        <>
            <WarningWrapper>
                <div>
                    <Icon.WarningV2 size="16px" color="none" strokeColor="#D97706" />
                </div>
                <div>
                    Please enable at least one payroll account to use this feature
                </div>
            </WarningWrapper>
            <Spacer bottom={20} />
        </>
    );

}

export default PunchRemindersInactivePayroll;